import React, { useState, useEffect } from "react";
import "./buypackages.css";
import NavbarCustom from "../../Components/NavbarCustom";
import { ImageContainer } from "../../Components/ImageContainerForPackages";
import { useNavigate } from "react-router-dom";
import { useBuyPackages } from "../../APIContext/BuyPackagesContext";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Swal from "sweetalert2";
import { useNewUser } from "../../APIContext/NewUserContext";
import SEO from "../../Components/SEO";
import Loader from "../../Components/Loader/Loader";

export const BuyPackages = () => {
  const { listPackages, fetchPackages, loading } = useBuyPackages();
  const { addToCart } = useNewUser();
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [isUnlimited, setIsUnlimited] = useState(false);
  const [isOneOnOneClicked, setIsOneOnOneClicked] = useState(true);
  const [isGroupClicked, setIsGroupClicked] = useState(false);
  const [type, setType] = useState("1-1");
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const navigate = useNavigate();

  function handleOneOnOneClick() {
    setIsOneOnOneClicked(true);
    setIsGroupClicked(false);
    setType("1-1");
  }

  function handleGroupClick() {
    setIsOneOnOneClicked(false);
    setIsGroupClicked(true);
    setType("Group");
  }

  useEffect(() => {
    fetchPackages();
  }, []);

  const handleProceed = () => {
    if (!selectedPackageId) {
      Swal.fire({
        icon: "warning",
        title: "No Package Selected",
        text: "Please select a package",
        confirmButtonColor: "#B79527",
      });
      return;
    }

    const data = {
      package_ids: [selectedPackageId],
    };

    if (user && isUnlimited === false) {
      // navigate(`/cart`);
      addToCart(data);
    } else {
      navigate(`/add-your-child?id=${selectedPackageId}`);
    }
  };

  const formatPackageName = (pkg) => {
    const sessionType = pkg.is_group_session ? "Group" : "1-on-1";
    const pkgDuration = pkg.name.split(" ")[1];
    const sportDetailFitness = pkg.sports_detail.name === "Fitness";

    if (pkg.is_unlimited) {
      return `Unlimited ${sessionType} Sessions`;
    }

    const count = pkg.session_count;
    const plural = count > 1 ? "Sessions" : "Session";

    if (sportDetailFitness) {
      return `${pkgDuration} ${sessionType} Session`;
    }

    return `${count} ${sessionType} ${plural}`;
  };

  return (
    <>
      <SEO
        title="BWC Sports | Buy packages"
        description=""
        url="https://bwcsports.com/buy-packages"
      />
      <NavbarCustom />
      {loading && <Loader />}

      <div className="buy-packages-sports-container">
        <div className="buy-packages-header">
          <BackBtn navigateTo={"/"} />
          <div className="buy-packages-header-content">
            <h1 className="buy-packages-heading black-text-clip">
              Buy Sports Packages
            </h1>
            <p className="black-text-clip">
              Choose a Sport Package for Your Child
            </p>
          </div>
        </div>

        <div className="filter-container" style={{ justifyContent: "center" }}>
          {/* <div className="space-adjuster"></div> */}
          <div className="buttons-container">
            <button
              className={`filter-button ${isOneOnOneClicked ? "clicked-btn" : ""}`}
              onClick={handleOneOnOneClick}
            >
              <span className="black-text-clip">1-1</span>
            </button>
            <button
              className={`filter-button ${isGroupClicked ? "clicked-btn" : ""}`}
              onClick={handleGroupClick}
            >
              <span className="black-text-clip">Group</span>
            </button>
          </div>
        </div>

        {/* SPORTS LOOP */}
        {/* SPORTS LOOP */}
        {listPackages.map((sportItem, sportIndex) => {
          // 1. Filter the packages FIRST to see if this sport has any valid packages for the current tab
          const filteredPackages = sportItem.packages.filter((pkg) =>
            isOneOnOneClicked ? !pkg.is_group_session : pkg.is_group_session,
          );

          // 2. If there are no packages after filtering, do not render the sport title/container at all
          if (filteredPackages.length === 0) {
            return null;
          }

          // 3. Otherwise, render the sport and its filtered packages
          return (
            <div className="buy-packages-preferred-sports" key={sportIndex}>
              <h2 className="black-text-clip">{sportItem.sport.name} Packages</h2>

              <div className="buy-packages-preferred-sports-container">
                {filteredPackages.map((pkg, pkgIndex) => {
                  const isSelected = selectedPackageId === pkg.id;

                  return (
                    <div
                      key={pkgIndex}
                      className="package-card"
                      onClick={() => {
                        setSelectedPackageId(pkg.id);
                        setIsUnlimited(pkg.is_unlimited);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <ImageContainer
                        // 4. Use pkg.image if it exists, otherwise fall back to the sport image
                        image={pkg.image ? pkg.image : sportItem.sport?.image}
                        name={formatPackageName(pkg)}
                        selected={isSelected}
                        price={pkg.price}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}

        <div className="p-submit-button-container">
          <button
            type="button"
            className="p-submit-button"
            onClick={handleProceed}
            disabled={selectedPackageId === null ? true : false}
          >
            {user && isUnlimited === false ? "Add to Cart" : "Add Your Child"}{" "}
            <i className="ri-shopping-cart-2-fill cart-icon"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default BuyPackages;
